export enum Platform {
  MAC_OS = 'macos',
  IOS = 'ios',
  OTHER = 'other',
}

const isMacLike = () => /Mac/i.test(navigator.platform);

const isIOS = () =>
  /iPad|iPhone|iPod/i.test(navigator.userAgent) || (isMacLike() && navigator.maxTouchPoints > 1);

export const getPlatform = (): Platform => {
  if (typeof navigator === 'undefined') {
    return Platform.OTHER;
  }

  if (isIOS()) {
    return Platform.IOS;
  }

  if (isMacLike()) {
    return Platform.MAC_OS;
  }

  return Platform.OTHER;
};

const usePlatform = () => {
  const platform = getPlatform();

  return {
    platform,
    isMac: platform === Platform.MAC_OS,
  };
};

export default usePlatform;
